import { StatsigConfigurations } from '@confluence/statsig-configurations/entry-points/StatsigConfigurations.ts';
import { UNSAFE_expValEqualsNoExposure } from '@confluence/feature-experiments';
import {
	MIGRATED_MACRO_EXTENSION_KEYS,
	isMigratedMacroImplEnabled,
} from '@confluence/macro-utils/entry-points/evaluateMacroEnablement.ts';

export function getMultiMacroQueryBlocklistFF(): string[] {
	const blocklist = StatsigConfigurations.getStringList(
		'confluence_frontend_macros_query_blocklist',
		[
			'jirachart',
			'jiraroadmap',
			'ui-button',
			'contentbylabel',
			'excerpt-include',
			'tasks-report-macro',
			'blog-posts',
			'section',
			'table-filter',
			'children',
			'pagetree',
			'detailssummary',
			'decisionreport',
		],
	);

	return String(blocklist)
		.split(',')
		.filter(
			(extensionKey) =>
				extensionKey !== 'include' ||
				!UNSAFE_expValEqualsNoExposure('cc_include_ssr_preload_cls', 'isEnabled', true),
		);
}

/**
 * Extension keys that the backend batch query must not render.
 *
 * The Statsig blocklist remains the source of truth for legacy macros that require individual
 * rendering. Enabled migrated macros are added on top of it at runtime.
 */
export function getEffectiveMultiMacroQueryBlocklist(): string[] {
	return Array.from(
		new Set([
			...getMultiMacroQueryBlocklistFF(),
			...MIGRATED_MACRO_EXTENSION_KEYS.filter(
				(extensionKey) =>
					isMigratedMacroImplEnabled(extensionKey) &&
					(extensionKey !== 'include' ||
						!UNSAFE_expValEqualsNoExposure('cc_include_ssr_preload_cls', 'isEnabled', true)),
			),
		]),
	);
}

/**
 * Blocklisted macros that still need the individual legacy SSR preloader.
 * Enabled migrated macros use preloadMacroData instead.
 */
export function getLegacyIndividualMacroQueryKeys(): string[] {
	return getMultiMacroQueryBlocklistFF().filter(
		(extensionKey) => !isMigratedMacroImplEnabled(extensionKey),
	);
}

export function canUseMultiMacroQuery(
	extensionKey: string | undefined,
	isNested2pBodiedExtension = false,
): boolean {
	return (
		!isNested2pBodiedExtension &&
		!getEffectiveMultiMacroQueryBlocklist().includes(extensionKey || '')
	);
}
